import React, { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { Tabs as VkitTabs } from 'vkit/lib/components';
import { TabType } from 'vkit/lib/shared/components/tabs/types/tabs.type';

export interface TabsProps<T = string> {
  setTabKey: Dispatch<SetStateAction<T>>;
  initialActiveTab: T;
  items: (TabType & { id: T })[];
}

export const Tabs = function Tabs<T>({ setTabKey, initialActiveTab, items }: TabsProps<T>) {
  const initialActiveTabIndex = useMemo(() => {
    return items.findIndex((tab) => tab.id === initialActiveTab);
  }, [initialActiveTab, items]);

  const [activeTabIndex, setActiveTabIndex] = React.useState(initialActiveTabIndex);

  const renderTabs = items.map((tab, index) => ({
    label: tab.label,
    active: index === activeTabIndex,
    onClick: () => setActiveTabIndex(index),
  }));

  useEffect(() => {
    setTabKey(items[activeTabIndex].id);
  }, [activeTabIndex, setTabKey, items]);

  return (
    <div data-testid='wrapper-tabs'>
      <VkitTabs iconDir='left' elements={[]} actions={renderTabs} onChange={setActiveTabIndex} />
    </div>
  );
};
